import { IUpdateProvisaoRecursoUseCase } from "../../../presentation/useCases/update/updade_provisao_recurso_servicos_use_case";
import { IQualidadeRepository } from "../../repositories/qualidade_repository";

// UpdateProvisaoRecursoUseCase

export class UpdateProvisaoRecursoUseCase implements IUpdateProvisaoRecursoUseCase {
  constructor(private readonly repository: IQualidadeRepository) {}

  async updateProvisaoRecurso(IdProvisaoRecurso: number, Recurso: string, Observacao: string | null, DataPrevistaDe: Date | null, DataPrevistaAte: Date | null, DataRealizadaDe: Date | null, DataRealizadaAte: Date | null, ValorPrevisto: string | number | null, ValorDesembolsado:string | number | null,
  ): Promise<void> {
    
    await this.repository.updateProvisaoRecurso(
      IdProvisaoRecurso, Recurso, Observacao, DataPrevistaDe, DataPrevistaAte, DataRealizadaDe, DataRealizadaAte, ValorPrevisto, ValorDesembolsado
    );
  }
}
